<template>
  <span class="font-logo text-xl sm:text-2xl focus:outline-none focus:ring rounded">
    <span><i class="fak fa-one"></i></span> ONE
  </span>
</template>
